import {Domain, createEndpoint} from '@esgi/contracts';

export class personalDomain extends Domain {
	public byUserId = createEndpoint<import('../../../../../../types/esgi.assets/subjects/get/by-user-id/result-with-base-response').ResultWithBaseResponse, import('../../../../../../types/esgi.assets/subjects/get/by-user-id/request').Request>('GET', '/v2/school-admins/modules/subjects/personal/by-user-id', this.clientFactory);
}
